import React from 'react'
import PropTypes from 'prop-types'
import { message, Button, Typography, Input, Icon, Form, Row, Col, Tooltip, Statistic, InputNumber } from 'antd';
import { Queries, Mutations } from '../../../../graphql'
import Container from '../../../../components/user/Container'
import { withApollo } from 'react-apollo'
import { ErrorMessageFormAPI } from '../../../../utils/checkError'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'
import moment from 'moment'

const { Text, Title } = Typography
const { Countdown } = Statistic;

class FormPhone extends React.Component {
    state = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false,
        disabledOTP:true,
        deadline: (Date.now()),
        otpToken: null,
        refCode: null,
        expiredAt: null,
        otpstate: false,
        telNo:null
    };

    handleSubmit = async (e) => {
        const { form, afterSubmit, client } = this.props
        const { telNo, otpToken, refCode, expiredAt } = this.state
		await e.preventDefault()
		form.validateFields(async (err, values) => {
			if (!err) {
                try {
                    
                    const { data, errors } = await client.mutate({
                        mutation: Mutations.changePhoneNumber,
                        variables: {
                            telNo,
                            otp:{
                                otpToken: otpToken,
                                refCode: refCode,
                                otpCode: values.otp,
                                expiredAt: expiredAt
                            }
                        }
                    })

                    console.log(data)

                    if(data){
                        message.success("ส่งเพื่อดำเนินการเรียบร้อย")
                        setTimeout(() => {
                            window.location.reload();
                        }, 600);
                    }
                }catch (error) {
                    
                }
			}
		})
	}

    setSMS = async () => {
        const { client, location } = this.props
        const { dataAddress, telNo } = this.state

        try {
            const { data, errors } = await client.query({
                query: Queries.requestSendingOTP,
                variables: {
                    telNo
                }
            })

            console.log('setSMS', data)
    
            if(data){
                this.setState({
                    disabledOTP:false,
                    otpstate:true,
                    deadline: Date.now() + 1000 * (moment(data.requestSendingOTP.endTime).unix() -  moment(data.requestSendingOTP.startTime).unix()),
                    otpToken: data.requestSendingOTP.otpToken,
                    refCode: data.requestSendingOTP.refCode,
                    expiredAt: data.requestSendingOTP.expiredAt
                })
            }
        }catch (error) {
            console.log(error)
        }
        
	}

    onChangePhoneNumber = async(e) =>{
        const { dataAddress } = this.state

        const reg = /^-?[0-9]*(\.[0-9]*)?$/;
        if ((!isNaN(e.target.value) && reg.test(e.target.value)) || e.target.value === '' || e.target.value === '-') {
            this.setState({
                telNo: e.target.value
            })
        }
    }

    onFinish = async () => {
        // console.log('finished!');
        await this.setState({ otpstate: false })
    }

    async componentDidMount() {
       
    }

    render() {
        const { match, form } = this.props
        const { getFieldDecorator } = form
        const { telNo, disabledOTP, otpstate, refCode } = this.state
        const testInfo = '<p class="mb-2">รหัสผ่านประกอบไปด้วย</p><ul class="pl-3"><li>อักษรภาษาอังกฤษตัวพิมพ์ใหญ่ (A-Z)</li><li>อักษรภาษาอังกฤษตัวพิมพ์เล็ก (a-z)</li><li>ตัวเลขอย่างน้อย 1 ตัว (0-9)</li><li>สัญลักษณ์พิเศษอย่างน้อย 1 ตัว (!@#S%^&*(_+<>?;) </li><li>ความยาวขั้นต่ำ 8 ตัวอักษร</li><li>ห้ามมีจุด (. ) ในรหัสผ่าน</li><li>ห้ามมีชื่อ หรือ นามสกุลภาษาอังกฤษในรหัสผ่าน</li></ul>'
        return (
            <Container match={match} className="page-change-password">
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <Row type="flex" justify="center" align="top">
                    <Col span={20}>
                        <div className="card-container" id="page-profile" >
                            <div className="p-4 card-bg-green" style={{ borderRadius: "20px" }}>
                                <div className="p-5" style={{ borderRadius: "20px", backgroundColor: "white" }}>
                                    <h3 className="">เบอร์โทรศัพท์ใหม่</h3>
                                    <Form onSubmit={this.handleSubmit}>
                                        <Row>
                                            <Col span={24}>
                                                <Form.Item 
                                                    label={<b>เบอร์โทรศัพท์ใหม่</b>} 
                                                    name="telNo" 
                                                    className="mb-0"
                                                >
                                                    <Input
                                                        value={telNo}
                                                        formatter={telNo => `${telNo}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                        onChange={this.onChangePhoneNumber}
                                                        maxLength={10}
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col span={24} className="mb-3">
                                                {
                                                    refCode &&
                                                    <Text style={{ fontSize:"10px"}}>กรุณากรอกเลข OTP ที่ส่งไปยังหมายเลข {telNo} (ref : {refCode} )</Text>
                                                }
                                            </Col>
                                    
                                            <Col span={24}>
                                                <Row>
                                                    <Col span={24}>
                                                        <Button 
                                                            type="primary" 
                                                            disabled={ otpstate } 
                                                            className="btn-link-page-custom-edit"
                                                            onClick={ this.setSMS }
                                                        >
                                                            ขอรหัสยืนยันตัวตน
                                                        </Button>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Text className='color-gray' style={{ fontSize: "10px" }}>
                                                            สามารถกดขอใหม่ได้อีกครั้งใน : 
                                                            <Countdown className="mt-1 pl-2" valueStyle={{ fontSize: "10px" }} value={this.state.deadline} format="mm:ss" onFinish={this.onFinish} style={{ display:"inline-block"}} />
                                                        </Text>
                                                    </Col>
                                                </Row>
                                            </Col>

                                            <Col span={24}>
                                                <Form.Item 
                                                    label={<b>รหัส OTP</b>} 
                                                    name="confirmNewPassword" 
                                                    className="mb-3"
                                                >
                                                    {
                                                    getFieldDecorator('otp', {
                                                        rules: [
                                                            { required: true, message: 'กรุณากรอก OTP' },
                                                        ]
                                                    })(
                                                        <Input
                                                            disabled={disabledOTP}
                                                            maxLength={6}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>

                                            <Col span={24}>
                                                <Form.Item style={{marginBottom: '15' }}>
                                                    <Button type="primary btn-color-default btn-custom color-white" htmlType="submit">
                                                        ยืนยัน
                                                    </Button>
                                                </Form.Item>

                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }
}

FormPhone.defaultProps = {
	autoFocus: false
}

FormPhone.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedFormPhone = Form.create()(FormPhone)
export default withApollo(WrappedFormPhone)